import { useState } from 'react'
import queryString from 'query-string'
import loginPost from '../api/LoginPost'
import { AUTHENTICATE, ROOT } from '../constants/links'
import * as HttpStatus from '../constants/http.codes'
import { STATE_LOADING } from '../constants/button.states'

const useMFA = ({ redirect, invalidCodeErrorMessage, genericErrorMessage }) => {
  const [code, setCode] = useState('')
  const [showError, setShowError] = useState(false)
  const [verifyButtonState, setVerifyButtonState] = useState(undefined)
  const [disabledForm, setDisabledForm] = useState(false)
  const [errorMessage, setErrorMessage] = useState(undefined)

  const isVerifyButtonDisabled = () => disabledForm || !code

  const handleCodeChange = event => setCode(event.target.value)

  const handleError = message => {
    setCode('')
    setShowError(true)
    setErrorMessage(message)
  }

  const doLogin = (csrf, credentials, mfa) => {
    setVerifyButtonState(STATE_LOADING)
    setDisabledForm(true)

    const data = {
      username: credentials.username,
      password: credentials.password,
      mfa: JSON.stringify(mfa),
      _csrf: csrf.token
    }

    loginPost(AUTHENTICATE, queryString.stringify(data))
      .then(response => {
        redirect(response.data.redirect_uri || ROOT)
      })
      .catch(error => {
        const { response } = error
        if (response?.status === HttpStatus.UNAUTHORIZED) {
          handleError(invalidCodeErrorMessage())
        } else {
          handleError(genericErrorMessage ? genericErrorMessage() : undefined)
        }
        setVerifyButtonState(null)
        setDisabledForm(false)
      })
  }

  return {
    code,
    showError,
    verifyButtonState,
    disabledForm,
    errorMessage,
    isVerifyButtonDisabled,
    handleCodeChange,
    doLogin
  }
}

export default useMFA
